import { useEffect, useState } from 'react';
import { AppConfig } from '../app/config';
import NoProductImage from './../assets/images/no_product_image.png';
import { formatDateTimeInIST } from './indiaDateFormate';
import { dataDecrypt, dataEncrypt } from '../app/utils/encryption-helper';
import { ApisService } from '../app/core/apis.service';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import LOGO from './../assets/images/vyapar_live_main_logo.png';

export const OrderHistory = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const [history, setHistory] = useState<any>();
  const location = useLocation();
  const navigation = useNavigate();
  const routerParams = useParams();
  const queryParams = new URLSearchParams(location.search);
  const businessName = queryParams.get("bu");

  useEffect(() => {
    const userContact = localStorage.getItem('userDetails');
    getUserOrdersHistory(userContact);
  }, []);

  const getUserOrdersHistory = async (userContact: any) => {
    setLoader(true);
    try {
      const payload = {
        contact: userContact
      }
      const res = await ApisService.getTransactionData('getOrdersByContact', dataEncrypt(JSON.stringify(payload)));
      if (res) {
        setHistory(JSON.parse(dataDecrypt(res?.data?.data)));
        setLoader(false);
      }
    }
    catch (err) {
      setLoader(false);
    }
  }

  const calculateAmount = (products: any[]) => {
    const totalAmount =
      products?.reduce((sum: number, item: any) => sum + (item?.total || 0), 0) ?? 0;
    return `₹ ${totalAmount.toLocaleString('en-IN')}`;
  };

  const goToHome = () => {
    navigation(`/order-form/${routerParams.id}`);
  }


  return (
    <div>
      <div className='primary-background p-2 align-items-center d-flex justify-content-between'>
        <div ><div>Order Form for</div> <b style={{ fontSize: 24 }}>{businessName}</b></div>
        <div className='text-end'><img src={LOGO} alt="" height={60} /></div>
      </div>
      <div className='text-end mt-2 mx-1'><button onClick={goToHome} className='fs-14 px-4 rounded'>Create New Order</button></div>
      <div className="mt-2 mb-3">
        {loader ? (
          <div className="d-flex justify-content-center align-items-center py-5">
            <div className="spinner-border text-primary" role="status">
            </div>
          </div>
        ) : (
          <>
            {history?.length > 0 ? (
              history.map((order: any, index: number) => (
                <div className="card mb-3 mx-1 shadow-sm" key={index}>
                  <div className="card-body p-3">
                    <div className="row border-bottom pb-2 mb-2 fs-14">
                      <div className="col-md-6">
                        <div className="fw-bold">
                          Seller: <span className="fw-normal">{order?.seller?.name}</span>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="fw-bold">
                          Items: <span className="fw-normal">
                            {order?.order_details?.products?.length}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-3 text-md-end">
                        <div className="fw-bold">
                          Total: <span className="text-success">
                            {calculateAmount(order?.order_details?.products)}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="fw-bold fs-14 mb-2">Products</div>

                    {order?.order_details?.products?.map((item: any, subIndex: number) => (
                      <div className="row align-items-center mb-2" key={subIndex}>
                        <div className="col-2 col-md-1">
                          <img
                            src={
                              item?.product_image
                                ? `${AppConfig.IMAGE_PATH}${item.product_image}`
                                : NoProductImage
                            }
                            className="rounded w-100"
                            alt="product"
                          />
                        </div>

                        <div className="col-10 col-md-11 fs-14">
                          <div className="fw-semibold">{item?.product_name}</div>
                          <div className="text-muted">
                            Quantity: <strong>{item?.quantity}</strong>
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className="text-end text-muted fs-13 border-top pt-2 mt-2">
                      Order Date: {formatDateTimeInIST(order?.created_date, 'date')}
                    </div>

                  </div>
                </div>
              ))
            ) : (
              <div className="text-center text-muted">No Orders Found</div>
            )}

            <div className="text-center">
              <button onClick={goToHome} className="fs-14 px-4 rounded">
                Create New Order
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
